import React, { useState } from 'react';

// ─── ACCORDION SECTION ────────────────────────────────────────────────────────
// A single collapsible group. Pass `openId`/`onToggle` to have a parent
// coordinate accordion behavior (opening one closes the rest); omit them and
// each section manages its own open/closed state independently.
export function AccordionSection({ id, icon, title, defaultOpen = false, openId, onToggle, children }) {
  const controlled = openId !== undefined;
  const [localOpen, setLocalOpen] = useState(defaultOpen);
  const isOpen = controlled ? openId === id : localOpen;

  function toggle() {
    if (controlled) onToggle(isOpen ? null : id);
    else setLocalOpen(o => !o);
  }

  return (
    <div className="accordion-section">
      <button type="button" className="accordion-section__header" onClick={toggle} aria-expanded={isOpen}>
        <span className="accordion-section__title">{icon} {title}</span>
        <span className={`accordion-section__chevron ${isOpen ? 'accordion-section__chevron--open' : ''}`}>›</span>
      </button>
      {isOpen && <div className="accordion-section__body">{children}</div>}
    </div>
  );
}
